import { __assign, __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import * as moment from 'moment-timezone';
import '../../../locale/i18next';
import { withResizeDetector } from 'react-resize-detector';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';
import { withTranslation } from 'react-i18next';
import CalendarControllers from '../../presentationals/CalendarControllers/CalendarControllers';
import Error from '../../presentationals/UI/Error/Error';
import * as utils from './CalendarUtlis/CalendarUtils';
import MomentEnum from '../../../enums/MomentEnum';
import Actions from '../../../enums/ActionsEnum';
import { st, classes } from './Calendar.st.css';
import Popups from '../../../enums/PopupsEnum';
import capitalize from '../../../utils/stringUtils';
import { tFormatMomentDate, shortMomentDate, getMomentWithFormat, } from '../../../utils/momentUtils';
import { DEFAULT_TIMEZONE } from '../../../constants';
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.firstEventRef = React.createRef();
        _this.timezoneChangeHandler = function (timezone) {
            var dateObject = _this.state.dateObject;
            moment.tz.setDefault(timezone);
            var dateObjectToSet = moment(dateObject).tz(timezone, true);
            var handleTimezoneChange = _this.props.handleTimezoneChange;
            var start = utils.getStartAndEndMonthDates(dateObject).start;
            handleTimezoneChange(timezone, start);
            _this.setState({ dateObject: dateObjectToSet, timezone: timezone });
        };
        _this.todayClickedHandler = function () {
            var onTodayClick = _this.props.onTodayClick;
            var dateObject = moment();
            var selectedTime = _this.props.isMobile
                ? moment().format(MomentEnum.yearMonthDay)
                : _this.state.selectedTime;
            _this.setState({ dateObject: dateObject, isTodayClicked: true, isManuOpen: false, selectedTime: selectedTime }, function () { return onTodayClick && onTodayClick(); });
        };
        _this.timePickerClickedHandler = function (toAdd) {
            //FixMe
            var timezone = _this.state.timezone;
            var dateToUpdate = __assign({}, _this.state.dateObject);
            dateToUpdate = moment(dateToUpdate).startOf(MomentEnum.monthString);
            dateToUpdate = toAdd
                ? moment(dateToUpdate).add(1, MomentEnum.months)
                : dateToUpdate.subtract(1, MomentEnum.months);
            var _a = utils.getStartAndEndMonthDates(dateToUpdate), start = _a.start, end = _a.end;
            var handleMonthChange = _this.props.handleMonthChange;
            var firstDate = moment(dateToUpdate).format(MomentEnum.yearMonthDay);
            _this.setState({
                dateObject: dateToUpdate,
                selectedTime: _this.props.isMobile ? firstDate : '',
                isTodayClicked: false,
            }, function () { return handleMonthChange(start, end, timezone, toAdd); });
        };
        _this.getMonth = function () {
            var dateObject = _this.state.dateObject;
            var _a = _this.props, t = _a.t, width = _a.width, locale = _a.locale;
            var month = capitalize(tFormatMomentDate(dateObject, locale, t), false);
            var localesNotToSlice = ['zh', 'ja', 'ko'];
            var localesToSliceReverse = ['hu', 'lt'];
            if (locale && width < 750 && localesToSliceReverse.includes(locale)) {
                month = "".concat(getMomentWithFormat(dateObject, locale, MomentEnum.fullYear), " ").concat(month.slice(5, 8), " ");
            }
            else if (locale && width < 750 && !localesNotToSlice.includes(locale)) {
                month = capitalize(shortMomentDate(dateObject, locale), false);
            }
            return month;
        };
        _this.cellSelectHandler = function (selectedTime) {
            _this.setState({ selectedTime: selectedTime }, _this.props.handleCellSelect);
        };
        _this.toggleManuHandler = function (toOpen) {
            _this.setState({ isManuOpen: toOpen });
        };
        _this.updateLocale = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, locale, i18n, t, _b, timezone, dateObject, dateObjectToSet;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, locale = _a.locale, i18n = _a.i18n, t = _a.t;
                        console.log({ locale: locale });
                        return [4 /*yield*/, i18n.changeLanguage(locale)];
                    case 1:
                        _c.sent();
                        moment.locale(locale);
                        _b = this.state, timezone = _b.timezone, dateObject = _b.dateObject;
                        dateObjectToSet = moment(dateObject.format()).tz(timezone, true);
                        this.setState(function (prevState) { return ({
                            dateObject: dateObjectToSet,
                            localeToggle: !prevState.localeToggle,
                        }); });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.actionHandler = (_a = {},
            _a[Actions.TODAY] = _this.todayClickedHandler,
            _a);
        _this.setFirstEventRef = function (eventRef) {
            _this.firstEventRef = eventRef;
        };
        _this.focusEvent = function () {
            var _a = _this.props, dates = _a.dates, isMobile = _a.isMobile;
            var selectedTime = _this.state.selectedTime;
            //@ts-ignore
            if (isMobile && dates[selectedTime]) {
                //@ts-ignore
                var eventClass = _this.firstEventRef.current.children[0].className;
                var firstEvent = document.getElementsByClassName(eventClass)[0];
                firstEvent.focus();
            }
        };
        var timezone = props.timezone ? props.timezone : DEFAULT_TIMEZONE;
        moment.tz.setDefault(timezone);
        var dateObject = moment().tz(timezone, true);
        _this.state = {
            dateObject: dateObject,
            timezone: timezone,
            expandedCellId: '',
            localeToggle: false,
            isManuOpen: false,
            isTodayClicked: false,
            selectedTime: props.isMobile
                ? moment().tz(timezone, true).format(MomentEnum.yearMonthDay)
                : '',
        };
        return _this;
    }
    Calendar.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, timezone, action, dateObject;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props.locale !== prevProps.locale;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateLocale()];
                    case 1:
                        _a = (_c.sent());
                        _c.label = 2;
                    case 2:
                        _a;
                        _b = this.props, timezone = _b.timezone, action = _b.action;
                        if (timezone !== prevProps.timezone) {
                            moment.tz.setDefault(timezone);
                            dateObject = moment(this.state.dateObject).tz(timezone, true);
                            //@ts-ignore
                            this.setState({ timezone: timezone, dateObject: dateObject });
                        }
                        if (action !== Actions.NO_ACTION && action !== prevProps.action) {
                            //@ts-ignore
                            this.actionHandler[action]();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Calendar.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('---lang---', this.props.locale);
                        return [4 /*yield*/, this.updateLocale()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Calendar.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, openPopup = _a.openPopup, error = _a.error, isTodayButtonStyleSecondary = _a.isTodayButtonStyleSecondary, isTimezoneShown = _a.isTimezoneShown, children = _a.children, isMobile = _a.isMobile, handleSetHeight = _a.handleSetHeight, calendarRef = _a.calendarRef, isNextDisabled = _a.isNextDisabled, isPrevDisabled = _a.isPrevDisabled, isLiveSite = _a.isLiveSite, locale = _a.locale, className = _a.className, onPreviousClicked = _a.onPreviousClicked, onNextClicked = _a.onNextClicked, timeToDisplay = _a.timeToDisplay, isWeekly = _a.isWeekly, isCalendarsShown = _a.isCalendarsShown, calendarsList = _a.calendarsList, isEditorX = _a.isEditorX;
        var _b = this.state, timezone = _b.timezone, localeToggle = _b.localeToggle, dateObject = _b.dateObject, isTodayClicked = _b.isTodayClicked, selectedTime = _b.selectedTime, isManuOpen = _b.isManuOpen;
        var month = this.getMonth();
        var showNextMonth = function () { return _this.timePickerClickedHandler(true); };
        var handleSetHeightMobile = handleSetHeight;
        var onPreviousClickedHandler = function () {
            //@ts-ignore
            isWeekly ? onPreviousClicked() : _this.timePickerClickedHandler(false);
        };
        var onNextClickedHandler = function () {
            //@ts-ignore
            isWeekly ? onNextClicked() : _this.timePickerClickedHandler(true);
        };
        var constrollersProps = {
            isEditorX: isEditorX,
            onPreviousClicked: onPreviousClickedHandler,
            onNextClicked: onNextClickedHandler,
            timeToDisplay: timeToDisplay ? timeToDisplay : month,
            locale: locale,
            className: classes.DesktopControllers,
            isTodayButtonStyleSecondary: isTodayButtonStyleSecondary,
            todayClicked: this.todayClickedHandler,
            onTimezoneChange: this.timezoneChangeHandler,
            timezone: this.state.timezone,
            isTimezoneShown: isTimezoneShown && !isMobile,
            isMobile: isMobile,
            optionsClickHandler: function (isEnterClicked) {
                return openPopup ? openPopup({ popup: Popups.MANU, isEnterClicked: isEnterClicked }) : null;
            },
            isNextDisabled: isNextDisabled,
            isPrevDisabled: isPrevDisabled,
            isWeekly: isWeekly,
            isCalendarsShown: isCalendarsShown,
            calendarsList: calendarsList,
        };
        var calendarControllers = error ? (React.createElement(Error, { isLiveSite: isLiveSite, error: error, localeToggle: localeToggle })) : (
        //@ts-ignore
        React.createElement(CalendarControllers, __assign({}, constrollersProps)));
        return (React.createElement(TPAComponentsProvider, { value: { mobile: isMobile, rtl: false } },
            React.createElement("div", { "aria-label": t('Google_Calendar_Expanded_GoogleCalendar'), id: month, ref: calendarRef, className: st(classes.root, { isMobile: isMobile, isManuOpen: isManuOpen, isWeekly: isWeekly }, className) },
                calendarControllers,
                React.createElement("div", { className: st(classes.Children, { isMobile: isMobile, isEditorX: isEditorX }) }, children({
                    dateObject: dateObject,
                    selectedTime: selectedTime,
                    onSelectCell: this.cellSelectHandler,
                    localeToggle: localeToggle,
                    isTodayClicked: isTodayClicked,
                    showNextMonth: showNextMonth,
                    handleSetHeightMobile: handleSetHeightMobile,
                    isManuOpen: isManuOpen,
                    month: month,
                    setFirstEventRef: this.setFirstEventRef,
                    focusEvent: this.focusEvent,
                    timezone: timezone,
                })))));
    };
    Calendar.defaultProps = {
        locale: 'en',
        timezone: DEFAULT_TIMEZONE,
        action: Actions.NO_ACTION,
        isTimezoneShown: true,
        isTodayButtonStyleSecondary: true,
        isError: false,
        handleTimezoneChange: null,
        isMobile: false,
        isStretchable: true,
        className: '',
    };
    return Calendar;
}(React.Component));
//@ts-ignore
export default withTranslation()(withResizeDetector(Calendar));
//# sourceMappingURL=Calendar.js.map